// extracted by mini-css-extract-plugin
module.exports = {"root":"SuggestedCreators_root__LRaHu"};